var adsBanner = function () {
    var windowWidth = $(window).width();
    var containerWidth = $(".container").width();
    $(".back-banner").width(((windowWidth - containerWidth) / 2) - 20);
    if (windowWidth > (containerWidth + 20)) {
        $(".back-banner").show();
    } else {
        $(".back-banner").hide();
    }
};
 
$(document).ready(function(){

    //$('.distric-results .district').matchHeight();
 
    adsBanner();
    $(window).resize(function () {
        adsBanner();
    });

    $('.distric-results .row').masonry({
	  	itemSelector: '.district',
	});
    
});